/* tslint:disable */
import {
  KanvasUser,
  PlayerGroup,
  ScheduleTimeframe,
  RotationItem,
  ScreenLayout
} from '../index';

declare var Object: any;
export interface CategoryRotationInterface {
  "id": string;
  "name": string;
  "categoryOrder"?: Array<any>;
  "kanvasUserId"?: string;
  "createdByIp"?: string;
  "lastUpdatedByIp"?: string;
  "createdAt": Date;
  "updatedAt": Date;
  "scheduleRotationId"?: string;
  kanvasUser?: KanvasUser;
  playerGroups?: PlayerGroup[];
  scheduleTimeframes?: ScheduleTimeframe[];
  rotationItems?: RotationItem[];
  screenLayout?: ScreenLayout;
}

export class CategoryRotation implements CategoryRotationInterface {
  "id": string;
  "name": string;
  "categoryOrder": Array<any>;
  "kanvasUserId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "scheduleRotationId": string;
  kanvasUser: KanvasUser;
  playerGroups: PlayerGroup[];
  scheduleTimeframes: ScheduleTimeframe[];
  rotationItems: RotationItem[];
  screenLayout: ScreenLayout;
  constructor(data?: CategoryRotationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CategoryRotation`.
   */
  public static getModelName() {
    return "CategoryRotation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CategoryRotation for dynamic purposes.
  **/
  public static factory(data: CategoryRotationInterface): CategoryRotation{
    return new CategoryRotation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CategoryRotation',
      plural: 'CategoryRotations',
      path: 'CategoryRotations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "categoryOrder": {
          name: 'categoryOrder',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "scheduleRotationId": {
          name: 'scheduleRotationId',
          type: 'string'
        },
      },
      relations: {
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        playerGroups: {
          name: 'playerGroups',
          type: 'PlayerGroup[]',
          model: 'PlayerGroup',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'categoryRotationId'
        },
        scheduleTimeframes: {
          name: 'scheduleTimeframes',
          type: 'ScheduleTimeframe[]',
          model: 'ScheduleTimeframe',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'categoryRotationId'
        },
        rotationItems: {
          name: 'rotationItems',
          type: 'RotationItem[]',
          model: 'RotationItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'categoryRotationId'
        },
        screenLayout: {
          name: 'screenLayout',
          type: 'ScreenLayout',
          model: 'ScreenLayout',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'categoryRotationId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/CategoryRotation.ts